import React, { useMemo } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import './MobileLayout.css';

export default function MobileLayout() {
  const location = useLocation();

  const isHome = useMemo(() => {
    const p = String(location.pathname || '');
    return p === '/m' || p === '/m/';
  }, [location.pathname]);

  const title = useMemo(() => {
    const p = String(location.pathname || '');
    if (p === '/m' || p === '/m/') return '首页';
    if (p.startsWith('/m/training')) return '教育培训';
    if (p.startsWith('/m/hazards')) return '隐患排查';
    if (p.startsWith('/m/checkin')) return '日常打卡';
    if (p.startsWith('/m/me')) return '个人信息';
    return '移动端';
  }, [location.pathname]);

  return (
    <div className="m-shell">
      {isHome ? null : (
        <header className="m-topbar">
          <div className="m-brand">
            <div className="m-brandName">企业安全管理平台</div>
            <div className="m-pageTitle">{title}</div>
          </div>
          <Link className="m-homeLink" to="/m">首页</Link>
        </header>
      )}

      <main className="m-content">
        <Outlet />
      </main>
    </div>
  );
}
